module.exports = __webpack_public_path__ + "img/simple-onboarding.5b16c429.png";